<script>
    import { onMount } from "svelte";
    import { getPiecesByMonth, generateBulkEmployeeCards, dialogType, dialogMessage, showDialog } from "../http.js";
    import Loader from "./Loader.svelte";
    import Icon from "./Icon.svelte";

    let pieces = [];
    let toggleLoader = false;
    let selectedMonth = new Date().getMonth() + 1; // Current month (1-12)
    let selectedYear = new Date().getFullYear();
    let downloadInProgress = false;
    const monthSelectId = 'pieces-month-select';
    const yearSelectId = 'pieces-year-select';
    
    // If we're in January or later, default to previous month
    if (selectedMonth === 1) {
        selectedMonth = 12;
        selectedYear -= 1;
    } else {
        selectedMonth -= 1;
    }

    const months = [
        { value: 1, label: "Styczeń" },
        { value: 2, label: "Luty" },
        { value: 3, label: "Marzec" },
        { value: 4, label: "Kwiecień" },
        { value: 5, label: "Maj" },
        { value: 6, label: "Czerwiec" },
        { value: 7, label: "Lipiec" },
        { value: 8, label: "Sierpień" },
        { value: 9, label: "Wrzesień" },
        { value: 10, label: "Październik" },
        { value: 11, label: "Listopad" },
        { value: 12, label: "Grudzień" }
    ];

    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);

    const loadPieces = async () => {
        toggleLoader = true;
        try {
            const monthParam = Number(selectedMonth);
            const yearParam = Number(selectedYear);
            pieces = await getPiecesByMonth(monthParam, yearParam);
        } catch (error) {
            showDialog.update(() => true);
            dialogType.update(() => "is-danger");
            dialogMessage.update(() => "Nie możemy pobrać danych o dziełach. Spróbuj ponownie.");
        } finally {
            toggleLoader = false;
        }
    };

    const handleMonthChange = () => {
        loadPieces();
    };

    const downloadAllEmployeeCards = async () => {
        downloadInProgress = true;
        try {
            await generateBulkEmployeeCards(Number(selectedMonth), Number(selectedYear));
        } catch (error) {
            showDialog.update(() => true);
            dialogType.update(() => "is-danger");
            dialogMessage.update(() => "Nie możemy pobrać kart pracowników. Spróbuj ponownie.");
        } finally {
            downloadInProgress = false;
        }
    };

    onMount(async () => {
        await loadPieces();
    });
</script>

<section class="view">
    <Loader state={toggleLoader}/>

    <div class="filter-bar">
        <label class="filter-bar__label" for={monthSelectId}>Miesiąc</label>
        <div class="select">
            <select id={monthSelectId} bind:value={selectedMonth} on:input={handleMonthChange}>
                {#each months as month}
                    <option value={month.value}>{month.label}</option>
                {/each}
            </select>
        </div>

        <label class="filter-bar__label" for={yearSelectId}>Rok</label>
        <div class="select">
            <select id={yearSelectId} bind:value={selectedYear} on:input={handleMonthChange}>
                {#each years as year}
                    <option value={year}>{year}</option>
                {/each}
            </select>
        </div>

        <div class="filter-bar__actions">
            <button type="button" class="button" class:is-loading={downloadInProgress}
                disabled={downloadInProgress} on:click={downloadAllEmployeeCards}>
                <Icon name="download"/> Pobierz karty pracowników
            </button>
        </div>
    </div>

    <div class="table-wrap">
        <table class="table table-modern is-fullwidth">
            <thead>
                <tr>
                    <th>Dzieło</th>
                    <th>Projekt</th>
                    <th>Okres</th>
                    <th>Zadania</th>
                    <th>Przypisani pracownicy</th>
                </tr>
            </thead>
            <tbody>
                {#if pieces.length === 0 && !toggleLoader}
                    <tr>
                        <td colspan="5">
                            <div class="empty-state">
                                <img src="/logo.png" alt="" width="48" height="48">
                                <p>Brak dzieł w wybranym miesiącu.</p>
                            </div>
                        </td>
                    </tr>
                {/if}
                {#each pieces as piece}
                    <tr>
                        <td>{piece.piece_name}</td>
                        <td><span class="chip">{piece.project_key}</span></td>
                        <td class="cell-sub is-nowrap">
                            {new Date(piece.start_date).toLocaleDateString('pl-PL')} –
                            {new Date(piece.end_date).toLocaleDateString('pl-PL')}
                        </td>
                        <td>{piece.task_count}</td>
                        <td>
                            <ul class="plain-list cell-sub">
                                {#each piece.employees as employee}
                                    <li>{employee.name} ({employee.email})</li>
                                {/each}
                            </ul>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</section>
